module.exports = __webpack_public_path__ + "img/image_3.26669d04.gif";